/**
 * 检验报告API模块
 * 支持查询后端报告和自定义上传
 * 注意：此模块调用主系统接口（/api/report），不使用 foodlabel 前缀
 */

import { request } from './client';

/**
 * 查询报告列表（分页）
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码，默认1
 * @param {number} params.pageSize - 每页数量，默认10
 * @param {string} params.name - 报告名称（可选）
 * @param {string} params.sampleName - 样品名称（可选）
 * @param {string} params.type - 报告类型（可选）
 */
export const queryReports = async (params = {}) => {
  return request('/api/report/selectPage', {
    method: 'GET',
    params: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      name: params.name,
      sampleName: params.sampleName,
      type: params.type
    },
    skipBaseUrl: true  // 跳过 /api/foodlabel 前缀，直接访问主系统接口
  });
};

/**
 * 根据报告编号查询报告
 * @param {string} reportCode - 报告编号
 */
export const queryReportByCode = async (reportCode) => {
  if (!reportCode || !reportCode.trim()) {
    throw new Error('报告编号不能为空');
  }
  return request('/api/report/selectByReportCode', {
    method: 'GET',
    params: { reportCode: reportCode.trim() },
    skipBaseUrl: true  // 跳过 /api/foodlabel 前缀，直接访问主系统接口
  });
};

/**
 * 根据ID查询报告
 * @param {number} id - 报告ID
 */
export const queryReportById = async (id) => {
  return request(`/api/report/selectById/${id}`, {
    method: 'GET',
    skipBaseUrl: true  // 跳过 /api/foodlabel 前缀，直接访问主系统接口
  });
};

/**
 * 检查报告编号是否存在
 * @param {string} reportCode - 报告编号
 */
export const checkReportCode = async (reportCode) => {
  return request('/api/report/checkReportCode', {
    method: 'GET',
    params: { reportCode },
    skipBaseUrl: true  // 跳过 /api/foodlabel 前缀，直接访问主系统接口
  });
};

/**
 * 获取报告文件下载URL
 * @param {number|string} reportId - 报告ID或报告编号
 * @param {boolean} isCode - 是否为报告编号，默认false
 */
export const getReportDownloadUrl = (reportId, isCode = false) => {
  if (isCode) {
    return `/api/report/downloadByCode?reportCode=${encodeURIComponent(reportId)}`;
  }
  return `/api/report/download/${reportId}`;
};

export default {
  queryReports,
  queryReportByCode,
  queryReportById,
  checkReportCode,
  getReportDownloadUrl
};

